(function(global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined'
    ? (module.exports = factory())
    : typeof define === 'function' && define.amd
    ? define(factory)
    : ((global = global || self), (global.RippleOverlay = factory()))
})(this, function() {
  function RippleOverlay(point, opts) {
    this.point = point
    this.opts = opts || {
      width: 20,
      height: 20,
      color: 'blue',
      click: null,
      mouseover: null,
      mouseout: null
    }
  }
  // 继承百度地图覆盖物基类
  RippleOverlay.prototype = new BMapGL.Overlay()
  RippleOverlay.prototype.initialize = function(bmap) {
    const dom = document.createElement('div')
    dom.classList.add('a-ripple')
    dom.style.zIndex = 99999
    dom.style.position = 'absolute'
    dom.style.width = this.opts.width + 'px'
    dom.style.height = this.opts.height + 'px'
    dom.style.backgroundColor = this.opts.color

    dom.onclick = this.opts.click
    dom.onmouseover = this.opts.mouseover
    dom.onmouseout = this.opts.mouseout

    bmap.getPanes().markerPane.appendChild(dom)
    this.bmap = bmap
    this.dom = dom

    return dom
  }
  RippleOverlay.prototype.draw = function() {
    const pixel = this.bmap.pointToOverlayPixel(this.point)
    this.dom.style.top = pixel.y - this.opts.height + 'px'
    this.dom.style.left = pixel.x - this.opts.width + 'px'
  }
  RippleOverlay.prototype.show = function() {
    if (this.dom) {
      this.dom.style.display = 'block'
    }
  }
  RippleOverlay.prototype.hide = function() {
    if (this.dom) {
      this.dom.style.display = 'none'
    }
  }
  RippleOverlay.prototype.toggle = function() {
    if (this.dom) {
      if (this.dom.style.display == 'block') {
        this.hide()
      } else {
        this.show()
      }
    }
  }

  return RippleOverlay
})
